module.exports = __webpack_public_path__ + "static/media/downtheroad.62e072cb.mp3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/downtheroad.mp3
 ** module id = 663
 ** module chunks = 0
 **/